import * as React from 'react';

import type {NotifyMessage} from 'nutshell-core/types';

import {RemoveButton} from '../button/remove-button/remove-button';
import {CloudDownloadIcon} from '../icon';

import styles from './notify-complete.module.css';

type Props = {
    notify: NotifyMessage;
    onAcknowledgeExport: (notify: NotifyMessage) => any;
    onAcknowledgeExportDownload: () => any;
};

export function NotifyComplete(props: Props) {
    const {name, hash, filename} = props.notify;

    const handleAcknowledgeExport = () => {
        props.onAcknowledgeExport(props.notify);
    };

    if (hash && filename) {
        return (
            <li key={name} className={styles['notify-complete']}>
                <RemoveButton size={10} onClick={handleAcknowledgeExport} />
                <a
                    onClick={props.onAcknowledgeExportDownload}
                    href={`/file/export?hash=${hash}&filename=${filename}&notifyId=${name}`}
                    className={styles['complete-text-container']}
                >
                    <span className={styles['notify-text']}>{filename}</span>
                    <div className={styles['icon']}>
                        <CloudDownloadIcon size={17} />
                    </div>
                </a>
            </li>
        );
    }

    return null;
}
